
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/transfer",
      function () {
        return require("private-next-pages/products/transfer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/transfer"])
      });
    }
  